var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.314452 11.7443C0.314452 11.3476 0.465944 10.9509 0.768291 10.6484L10.2873 1.12944C10.8928 0.523911 11.8746 0.523911 12.4799 1.12944C13.0852 1.73472 13.0852 2.71628 12.4799 3.32186L4.05692 11.7443L12.4796 20.1668C13.0849 20.7724 13.0849 21.7538 12.4796 22.3591C11.8743 22.9649 10.8925 22.9649 10.287 22.3591L0.767997 12.8403C0.4656 12.5376 0.314452 12.1409 0.314452 11.7443Z",
    fill: "#1D4EAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.e0516449ae9a04e4e26a22fca58514df.svg";
export { ForwardRef as ReactComponent };